// extracted by mini-css-extract-plugin
export var bounce = "_ll-1";
export var generatingText = "_ll-6";
export var lightning = "_ll-4";
export var popup = "_ll-5";
export var progressBar = "_ll-7";
export var progressFill = "_ll-8";
export var progressShimmer = "_ll-9";
export var progressText = "_ll-a";
export var shimmer = "_ll-3";
export var uploadIcon = "_ll-0";
export var uploadingText = "_ll-2";